import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.routes').then((m) => m.PagesRoutes),
  },
  // {
  //   path: '**',
  //   redirectTo: 'home',
  // },
];
